/**
 * Pad a number with leading zeros
 * @param {number} n The number to pad with zeros
 * @param {number} [size] The size to pad to (default 2) 
 * @returns {string} The number padded with leading zeros
 */
function pad(n, size) {
  if (typeof n !== 'number')
    throw new Error('n must be a number');
  if (typeof size !== 'number')
    size = 2;
  return `${Math.floor(Math.abs(n))}`.padStart(size, '0');
}

/**
 * Get the timezone offset to append to an ISO8601-like timestamp
 * @param {Date} date The date to use
 * @returns {string} The timezone offset to append to ISO 8601-like date
 */
function getTzOffset(date) {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? '+' : '-';
  return diff + pad(tzOffset / 60, 2) + ':' + pad(tzOffset % 60, 2);
}

/**
 * Convert a Date to an ISO8601-like timestamp with local time
 * @param {Date} date 
 * @param {Boolean} [includeTz]
 */
function toISOStringLocal(date, includeTz = false) {
  let isoLike = date.getFullYear() +
    '-' + pad(date.getMonth() + 1, 2) +
    '-' + pad(date.getDate(), 2) +
    'T' + pad(date.getHours(), 2) +
    ':' + pad(date.getMinutes(), 2) +
    ':' + pad(date.getSeconds(), 2);
  if (includeTz === true) isoLike += getTzOffset(date);
  return isoLike
}

/**
 * Updates a local and UTC timestamp in the DOM
 */
export function updateTime() {
  const elLocalTime = document.getElementById('localTime');
  const elUtcTime = document.getElementById('utcTime');
  if (!elLocalTime && !elUtcTime) return;
  const now = new Date();
  if (elLocalTime) {
    const localTime = toISOStringLocal(now).replace('T', ' ');
    const zone = now.toLocaleTimeString('en-US', { timeZoneName: 'short' })
      .split(' ')[2];
    elLocalTime.textContent = `Local (${zone}): ${localTime}`;
  }
  if (elUtcTime) {
    const utcTime = now.toISOString().split('.')[0].replace('T', ' ');
    elUtcTime.textContent = `UTC: ${utcTime}`;
  }
}